import { apiClient } from './api'

export interface HierarchyLevel {
  id: number
  org_id: number
  level_number: number
  display_name: string
  plural_name: string
  is_required: boolean
  max_depth: number | null
}

export interface HierarchyNode {
  id: number
  org_id: number
  level_id: number
  parent_node_id: number | null
  name: string
}

export const hierarchyService = {
  getLevels: (orgId: number) =>
    apiClient.get<HierarchyLevel[]>('/api/v1/hierarchy/levels', { params: { org_id: orgId } }).then(r => r.data),

  createLevel: (orgId: number, data: Omit<HierarchyLevel, 'id' | 'org_id'>) =>
    apiClient.post<HierarchyLevel>('/api/v1/hierarchy/levels', data, { params: { org_id: orgId } }).then(r => r.data),

  updateLevel: (levelId: number, data: Partial<HierarchyLevel>) =>
    apiClient.patch<HierarchyLevel>(`/api/v1/hierarchy/levels/${levelId}`, data).then(r => r.data),

  deleteLevel: (levelId: number) =>
    apiClient.delete(`/api/v1/hierarchy/levels/${levelId}`),

  getNodes: (orgId: number, levelId?: number, parentNodeId?: number) =>
    apiClient.get<HierarchyNode[]>('/api/v1/hierarchy/nodes', {
      params: { org_id: orgId, level_id: levelId, parent_node_id: parentNodeId },
    }).then(r => r.data),

  createNode: (orgId: number, data: Omit<HierarchyNode, 'id' | 'org_id'>) =>
    apiClient.post<HierarchyNode>('/api/v1/hierarchy/nodes', data, { params: { org_id: orgId } }).then(r => r.data),

  deleteNode: (nodeId: number) =>
    apiClient.delete(`/api/v1/hierarchy/nodes/${nodeId}`),
}
